var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    optionsInputMargin: spacing.small,
    optionsInputFontSize: typography.fontSizeSmall,
    optionsInputFontWeight: typography.fontWeightNormal,
    optionsInputBorderRadius: borders.radiusMedium,
    optionsInputConditionalMargin: spacing.xSmall,
    optionsInputPadding: spacing.xSmall,
    optionInputFocusBackColor: colors.white,
    optionInputFocusColor: colors.licorice,
    optionsInputCheckbox: spacing.xxSmall
  };
};
export default generateComponentTheme;